/**
 * SankalpamPage — Port of sankalpam.page (Full daily sankalpam generator)
 * Warm traditional theme
 */
import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { getPaksham, getVaasaram, getAyane, getRuthu, getMaseTamil, getNakshatraYukthayaam, getThithyam, PANCHANGAM_API } from '@/panchangam/services/panchangam-utils';

const T = {
  bgPage: '#f0f5e8', bgGreenPale: '#e8f5e9', bgCream: '#fffef0',
  textGreenDark: '#1b5e20', textMaroon: '#6d1b1b', accentOrange: '#e65100',
  borderGreen: '#c8e6c9', gold: '#f0d48a',
  headerBg: 'linear-gradient(135deg, #090b72, #1a237e)',
};

const SankalpamPage = () => {
  const [pd, setPd] = useState(null);
  const [loading, setLoading] = useState(true);
  const [today, setToday] = useState(dayjs().format('YYYY-MM-DD'));

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(PANCHANGAM_API, { params: { date: today, time: '12pm' } });
      if (res.data[0]) setPd(res.data[0]);
    } catch { setPd(null); }
    finally { setLoading(false); }
  }, [today]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const fn = (v) => v != null ? Number(v).toFixed(2) : '';

  if (loading) return <div style={{textAlign:'center',padding:'60px',color:T.textGreenDark,fontWeight:'bold'}}>Please wait ....</div>;
  if (!pd) return <div style={{textAlign:'center',padding:'60px',color:T.textMaroon}}>தரவு கிடைக்கவில்லை</div>;

  const c = {
    paksham: getPaksham(pd.PakshamNameInTamil, pd.Paksham),
    vasaram: getVaasaram(pd.EnglishDay),
    ayanam: getAyane(pd.TamilMonthNumber),
    ruthu: getRuthu(pd.TamilMonthNumber),
    masam: getMaseTamil(pd.TamilMonthNumber),
    nakshatram: getNakshatraYukthayaam(pd.NakshatraNumber),
    nakshatram2: getNakshatraYukthayaam(pd.Nakshatra2Number),
    thithiyam: getThithyam(pd.ThithiNumber),
    thithyam2: getThithyam(pd.Thithi2Number),
  };

  return (
    <div style={{ padding: '10px', background: T.bgPage, minHeight: '80vh' }}>
      <div style={{ background: T.headerBg, padding: '14px', borderRadius: '12px', textAlign: 'center', marginBottom: '12px', borderBottom: '3px solid #ff9800' }}>
        <img src="/images/rituals/Sankalpam.jpg" alt="ஸங்கல்பம்" style={{height:'50px',borderRadius:'8px',marginBottom:'6px',border:'2px solid #f0d48a'}} />
        <h2 style={{ color: 'white', margin: 0, fontSize: '1.1rem', fontWeight: 800 }}>📜 இன்று முழு ஸங்கல்பம்</h2>
        <div style={{ color: T.gold, fontSize: '0.85rem', marginTop: '4px' }}>{pd.EnglishDate} - {pd.DayNameInTamil}</div>
      </div>
      <div style={{ textAlign: 'center', marginBottom: '12px' }}>
        <input type="date" value={today} onChange={e => setToday(e.target.value)}
          style={{ padding: '8px 16px', borderRadius: '8px', border: `2px solid ${T.textGreenDark}`, fontSize: '1rem', background: T.bgCream }} />
      </div>
      <div style={{ backgroundColor: T.bgCream, borderRadius: '12px', padding: '18px', lineHeight: 1.9, fontSize: '0.95rem', color: T.textMaroon, border: `1px solid ${T.borderGreen}` }}>
        <div style={{ textAlign: 'center', fontWeight: 800, color: T.textGreenDark, marginBottom: '14px', fontSize: '1.15rem' }}>ஸங்கல்பம்</div>
        <p>ஸ்ரீமதே ராமாநுஜாய நம: | ஸ்ரீமதே நிகமாந்த மஹாதேசிகாய நம: |</p>
        <p>அபவித்ர: பவித்ரோ வா ஸர்வாவஸ்தாம் கதோ அபிவா | ய: ஸ்மரேத் புண்டரீகாக்ஷம் ஸ பாஹ்ய-அப்யந்தர ஸுச்சி: ||</p>
        <p style={{ fontWeight: 700, color: T.accentOrange }}>
          {pd.YearNameInTamil} நாம ஸம்வத்ஸரே - {c.ayanam} - {c.ruthu} ருதௌ - {c.masam} மாஸே - {c.paksham} பக்ஷே -
        </p>
        <p>
          {c.thithiyam} ({fn(pd.ThithiDuration)}) சுப திதௌ -
          <span style={{backgroundColor:'#fff8e1',padding:'2px 6px',borderRadius:'4px',border:'1px solid #f9a825'}}> (அடுத்த திதி: {c.thithyam2})</span>
        </p>
        <p>
          வாஸர: {c.vasaram} வாஸர யுக்தாயாம் - {c.nakshatram} ({fn(pd.NakshatraDuration)}) நக்ஷத்ர யுக்தாயம்
          <span style={{backgroundColor:'#fff8e1',padding:'2px 6px',borderRadius:'4px',border:'1px solid #f9a825'}}> (அடுத்த நக்ஷத்ரம்: {c.nakshatram2})</span>
        </p>
        <p>
          {pd.YogaNameInTamil} ({fn(pd.YogaDuration)}) யோக யுக்தாயாம்
          <span style={{backgroundColor:'#fff8e1',padding:'2px 6px',borderRadius:'4px',border:'1px solid #f9a825'}}> (அடுத்த யோகம்: {pd.Yoga2NameInTamil})</span>
        </p>
        <p>
          {pd.KaranamNameInTamil} ({fn(pd.KaranaDuration)}) கரண யுக்தாயாம்
          <span style={{backgroundColor:'#fff8e1',padding:'2px 6px',borderRadius:'4px',border:'1px solid #f9a825'}}> (அடுத்த கரணம்: {pd.Karanam2NameInTamil})</span>
        </p>
        <p style={{ fontWeight: 700, color: T.textGreenDark }}>
          ஏவங்குண விசேஷண விசிஷ்டாயாம் அஸ்யாம் {c.thithiyam} சுப / புண்ய திதௌ .......
        </p>
      </div>
    </div>
  );
};
export default SankalpamPage;
